module.exports = __webpack_public_path__ + "img/mountain.3bef7d3c.png";